import { render, staticRenderFns } from "./ChannelTreeNavMenu.vue?vue&type=template&id=bdb1c11a&scoped=true&"
import script from "./ChannelTreeNavMenu.vue?vue&type=script&lang=ts&"
export * from "./ChannelTreeNavMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelTreeNavMenu.vue?vue&type=style&index=0&id=bdb1c11a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb1c11a",
  null
  
)

export default component.exports